import React, { useEffect, useRef, useState } from "react";
import {
  ChevronRightIcon,
  TickCircleIcon,
} from "../../../../helper/HwIcon";

const FACILITIES_COLLAPSED_H = 420;
const computeFacilityCols = () => {
  if (typeof window === "undefined") return 4;
  const w = window.innerWidth;
  if (w <= 479) return 1;
  if (w <= 767) return 2;
  if (w <= 1199) return 3;
  return 4;
};

export const HotelFacilities = ({data,categories}) => {
  const [showAllFacilities, setShowAllFacilities] = useState(false);
  const [facilities,setfacilities] = useState([])
  const gridRef = useRef(null);
  const [needsClamp, setNeedsClamp] = useState(false);
  const [cols, setCols] = useState(computeFacilityCols());

  useEffect(() => {
    const onResize = () => setCols(computeFacilityCols());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const el = gridRef.current;
    if (!el) { setNeedsClamp(false); return; }
    setNeedsClamp(el.scrollHeight > FACILITIES_COLLAPSED_H + 60);
  }, [facilities, cols]);

  useEffect(()=>{
    if(Array.isArray(data)){
      let formatData = data?.map((amt)=>{
        return {
          title : amt?.text,
          items : amt?.amenities?.map(a => a?.name)
        }
      })
      setfacilities(formatData)
    }
  },[])

  const toggleFacilities = () => {
    setShowAllFacilities(!showAllFacilities);
  };
  const getTotalFacilitiesCount = () => {
    if (facilities.length > 0) {
      return facilities.reduce((total, category) => {
        return total + (category?.items?.length || 0);
      }, 0);
    }
    return 80;
  };

  const shouldShowViewMore = () => {
    if (facilities.length > 0) {
      const hasItems = facilities.some(category => category?.items && category.items.length > 0);
      if (!hasItems) {
        return false;
      }
      const totalCount = getTotalFacilitiesCount();
      return totalCount >= 3;
    }
    return true;
  };

  const totalFacilitiesCount = getTotalFacilitiesCount();
  const showViewMore = shouldShowViewMore();

  const renderFacilityCategory = (category, index) => (
    <div key={index} className="hw-hotel--facilityCol">
      <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
        <TickCircleIcon />
        {category?.title}
      </div>
      <ul className="no-list">
        {category?.items?.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  );
  return (
    <div id="hotel_facilities" className="hw-hotel--singleListSection">
      <h2 className="h4 mb-20">Hotel Facilities</h2>
      <div className="hw-section--box">
        <div className="hw-hotel--facilitiesPopular">
          <div className="hw-fontBold hw-gray-900 hw-text20 mb-20">
            Popular Amenities
          </div>
          <div className="hw-amenity--chips">
            {
              (categories?.length > 0
                ? categories.map((a) => a?.name).filter(Boolean)
                : ["Breakfast Available", "Double Bed", "Free Internet Access", "Family-Friendly"]
              ).map((name, i) => (
                <span className="hw-amenity--chip" key={i}>
                  <TickCircleIcon />
                  <span>{name}</span>
                </span>
              ))
            }
          </div>
        </div>

        <div
          className={`hw-hotel--facilitiesList${showAllFacilities ? " show" : ""
            }`}
        >
          {
            facilities.length > 0 ? (
              <div
                className="hw-hotel--facilitiesClamp"
                style={{
                  position: "relative",
                  maxHeight: (!showAllFacilities && needsClamp) ? `${FACILITIES_COLLAPSED_H}px` : undefined,
                  overflow: (!showAllFacilities && needsClamp) ? "hidden" : undefined,
                  transition: "max-height .4s ease",
                }}
              >
                <div className="hw-hotel--facilitiesGrid" ref={gridRef} style={{ columnCount: cols, columnGap: "2.4rem" }}>
                  {facilities.map(renderFacilityCategory)}
                </div>
                {(!showAllFacilities && needsClamp) ? (
                  <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, height: "6rem", background: "linear-gradient(to bottom, rgba(255,255,255,0), #fff)", pointerEvents: "none" }} />
                ) : null}
              </div>
            )
              :
              <div className="row">
                <div className="col-md-3">
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Access
                  </div>
                  <ul className="no-list">
                    <li>24*7 Front Desk</li>
                    <li>Express Check-in/out</li>
                    <li>Intercom</li>
                    <li>Non-smoking rooms</li>
                    <li>Paid parking</li>
                    <li>Private Check-in/out</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Safety and security
                  </div>
                  <ul className="no-list">
                    <li>24*7 Security</li>
                    <li>CCTV in common areas</li>
                    <li>Fire extinguisher</li>
                    <li>Safety/security feature</li>
                    <li>Smoke detectors</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Room amenities
                  </div>
                  <ul className="no-list">
                    <li>Air-conditioned rooms</li>
                    <li>Daily housekeeping</li>
                    <li>Balcony/terrace</li>
                    <li>Dustbins</li>
                    <li>Fan</li>
                    <li>First Aid kit</li>
                    <li>Free drinking water</li>
                    <li>Hand sanitiser</li>
                    <li>Ironing facilities</li>
                    <li>Study table</li>
                    <li>Telephone</li>
                    <li>Television</li>
                    <li>Safety Deposit Box</li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Transfers and transport
                  </div>
                  <ul className="no-list">
                    <li>Onsite car parking</li>
                    <li>Airport transfer</li>
                    <li>Taxi/Cab service</li>
                    <li>Paid parking</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Internet access
                  </div>
                  <ul className="no-list">
                    <li>Internet services</li>
                    <li>Airport transfer</li>
                    <li>Taxi/Cab service</li>
                    <li>Paid parking</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Food and drinks
                  </div>
                  <ul className="no-list">
                    <li>Buffet Breakfast</li>
                    <li>Room Service</li>
                    <li>Bar</li>
                    <li>BBQ Facility</li>
                    <li>Alternative Meal Arrangement</li>
                    <li>Coffee Shop</li>
                    <li>Water Bottles</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Activities and sports
                  </div>
                  <ul className="no-list">
                    <li>Outdoor Swimming Pool</li>
                    <li>Game room</li>
                    <li>Dartboard</li>
                    <li>Tours</li>
                    <li>BBQ Facility</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Outdoor
                  </div>
                  <ul className="no-list">
                    <li>Balcony/terrace</li>
                    <li>Game room</li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Family and kids
                  </div>
                  <ul className="no-list">
                    <li>Onsite car parking</li>
                    <li>Airport transfer</li>
                    <li>Taxi/Cab service</li>
                    <li>Paid parking</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Bathroom
                  </div>
                  <ul className="no-list">
                    <li>Private bathroom</li>
                    <li>Shower</li>
                    <li>Toiletries</li>
                    <li>Towels</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Beauty and Spa
                  </div>
                  <ul className="no-list">
                    <li>Facial Treatments</li>
                    <li>Salon</li>
                    <li>Manicure/Pedicure</li>
                    <li>Steam and Sauna</li>
                    <li>Massage</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Outdoor Activities
                  </div>
                  <ul className="no-list">
                    <li>Vehicle Rentals</li>
                    <li>Tours and Treks</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Outdoor
                  </div>
                  <ul className="no-list">
                    <li>Balcony/terrace</li>
                    <li>Game room</li>
                    <li>Dartboard</li>
                    <li>Tours</li>
                    <li>BBQ Facility</li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Services and conveniences
                  </div>
                  <ul className="no-list">
                    <li>Luggage Storage</li>
                    <li>Laundry Service</li>
                    <li>Contactless Check-in/Check-out</li>
                    <li>Currency Exchange</li>
                    <li>Dry-Cleaning</li>
                    <li>Food Delivery</li>
                    <li>Invoice Provided</li>
                    <li>Library</li>
                    <li>Smoke-Free Property</li>
                    <li>Smoking Area</li>
                    <li>Concierge</li>
                    <li>Air conditioning in Public Area</li>
                    <li>Free car parking</li>
                    <li>Terrace</li>
                  </ul>
                  <div className="d-flex hw-gapy10 align-items-center hw-black hw-fontBold hw-text18 hw-icon--div">
                    <TickCircleIcon />
                    Safety and cleanliness
                  </div>
                  <ul className="no-list">
                    <li>Anti-Viral Cleaning Items</li>
                    <li>Body Thermometer</li>
                    <li>Breakfast Takeaway Service</li>
                    <li>Cashless Payment Service</li>
                    <li>Common Area Disinfection (Daily)</li>
                    <li>Doctor/Nurse on Call</li>
                    <li>Hot water linen and laundry washing</li>
                    <li>Individually-wrapped food options</li>
                    <li>Mask-wearing staff</li>
                    <li>Physical Distancing of at least 1 metre</li>
                    <li>Regular Sanitisation of Rooms</li>
                  </ul>
                </div>
              </div>
          }
          {/* <div className="hw-bprimary--link mt-16">View 80+ More<ChevronRightIcon /></div> */}
          {(facilities.length > 0 ? needsClamp : showViewMore) && (
            <div className="hw-bprimary--link mt-16" onClick={toggleFacilities}>
              {showAllFacilities ? "View Less" : `View ${totalFacilitiesCount} More`}
              <ChevronRightIcon />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
